// components/Modal/FreeCancellationModal.js

import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import Typography from '../Typography';
import Button from '../Button/Button';
import InputTextArea from '../Input/InputTextArea';
import { theme } from '../../theme';

const FreeCancellationModal = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  const { t } = useTranslation('freeCancellationModal');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(message.trim());
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  // Limpiar el mensaje cuando el modal se cierre
  React.useEffect(() => {
    if (!isOpen) {
      setMessage('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal onClose={handleClose} title={t('title')}>
      <ModalContent>
        <ModalHeader>
          <Typography $variant="body-1-regular" color={theme.colors.defaultStrong}>
            {t('description')}
          </Typography>
          <Typography $variant="body-3-regular" color={theme.colors.defaultWeak}>
            {t('subtitle')}
          </Typography>
        </ModalHeader>

        <Form onSubmit={handleSubmit}>
          <TextAreaContainer>
            <InputTextArea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t('placeholder')}
              rows={4}
              maxLength={300}
              style={{ minHeight: '100px', resize: 'vertical' }}
            />
            <CharacterCount>
              {message.length}/300
            </CharacterCount>
          </TextAreaContainer>

          <ButtonContainer>
            <Button
              type="button"
              $variant="ghost"
              size="l"
              sizeTablet="l"
              sizeMobile="m"
              onClick={handleClose}
              disabled={isLoading}
            >
              {t('buttons.back')}
            </Button>
            <Button
              type="submit"
              size="l"
              sizeTablet="l"
              sizeMobile="m"
              $variant="outlineDanger"
              disabled={isLoading}
            >
              {isLoading ? t('buttons.cancelling') : t('buttons.cancel')}
            </Button>
          </ButtonContainer>
        </Form>
      </ModalContent>
    </Modal>
  );
};

export default FreeCancellationModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  max-width: 500px;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  position: relative;
`;

const CharacterCount = styled.span`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.defaultWeak};
  font-size: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.sm};
  justify-content: space-between;
`;